<template>
  <div class='default'>
    <el-dropdown-menu>
      <div class="case-container">
        <el-row :gutter="20">
          <!-- 左侧图片区域 -->
          <el-col :span="6">
            <div class="case-image">
              <div class="image-desc">
                <p>AICNOC致力于为企业带来显著的竞争优势：降低开发成本、提高安全性、助力生产运维</p>
              </div>
              <img src="./img/logo.png" alt="" />
            </div>
          </el-col>

          <!-- 右侧四栏布局 -->
          <el-col :span="18">
            <el-row>
              <!-- 第一栏：政务行业 -->
              <el-col :span="6">
                <div class="case-section">
                  <div class="section-top">基础架构</div>
                  <p class="section-desc">打造安全可信的<span>云</span>环境</p>
                  <div class="case-item case-item-cursor" @click="handleCaseClick('Container')">
                    <div class="case-icon">
                      <img src="./img/Books&Webinar@2x.png">
                    </div>
                    <div class="case-content">
                      <h4>轻量云平台</h4>
                      <p>中小企业上云的新选择</p>
                    </div>
                  </div>
                  <div class="case-item case-item-cursor" @click="handleCaseClick('LightweightCloud')">
                    <div class="case-icon">
                      <img src="./img/Partners@2x.png">
                    </div>
                    <div class="case-content">
                      <h4>容器云平台</h4>
                      <p>助力行业数字化转型</p>
                    </div>
                  </div>
                  <div class="case-item case-item-cursor" @click="handleCaseClick('MulticloudManagement')">
                    <div class="case-icon">
                      <img src="./img/Help Center@2x.png">
                    </div>
                    <div class="case-content">
                      <h4>多云管理平台</h4>
                      <p>助力企业落地云战略</p>
                    </div>
                  </div>
                </div>
              </el-col>

              <!-- 第二栏：教育行业 -->
              <el-col :span="6">
                <div class="case-section">
                  <div class="section-top">核心算力</div>
                  <p class="section-desc">一体化云<span>算</span>能平台</p>
                  <div class="case-item case-item-cursor" @click="handleCaseClick('MultiPowerManagement')">
                    <div class="case-icon">
                      <img src="./img/Developer-Docs@2x.png">
                    </div>
                    <div class="case-content">
                      <h4>多算力云平台</h4>
                      <p>一体化治理算力管理</p>
                    </div>
                  </div>
                  <div class="case-item case-item-cursor" @click="handleCaseClick('GpuVirtualization')">
                    <div class="case-icon">
                      <img src="./img/Integrations@2x.png">
                    </div>
                    <div class="case-content">
                      <h4>GPU虚拟化</h4>
                      <p>更灵活、高效使用GPU</p>
                    </div>
                  </div>
                </div>
              </el-col>

              <!-- 第三栏：通用解决方案 -->
              <el-col :span="6">
                <div class="case-section">
                  <div class="section-top">智能运维</div>
                  <p class="section-desc">全栈智能云<span>网</span>运维</p>
                  <div class="case-item case-item-cursor" @click="handleCaseClick('NetCare')">
                    <div class="case-icon">
                      <img src="./img/Behavioral@2x.png" alt="" srcset="">
                    </div>
                    <div class="case-content">
                      <h4>NetCare</h4>
                      <p>一点接入、全网无忧</p>
                    </div>
                  </div>
                  <div class="case-item case-item-cursor" @click="handleCaseClick('CloudCare')">
                    <div class="case-icon">
                      <img src="./img/Adoption@2x.png" alt="" srcset="">
                    </div>
                    <div class="case-content">
                      <h4>CloudCare</h4>
                      <p>助力网络运维更轻松</p>
                    </div>
                  </div>
                  <div class="case-item case-item-cursor" @click="handleCaseClick('CloudMigration')">
                    <div class="case-icon">
                      <img src="./img/Refresh@2x.png" alt="" srcset="">
                    </div>
                    <div class="case-content">
                      <h4>云迁移工具</h4>
                      <p>全栈迁移护航企业数字化跃迁</p>
                    </div>
                  </div>
                </div>
              </el-col>
              <!-- 第三栏：通用解决方案 -->
              <el-col :span="6">
                <div class="case-section">
                  <div class="section-top">应用拓展</div>
                  <p class="section-desc"><span>智</span>能应用</p>
                  <div class="case-item case-item-cursor"  @click="handleCaseClick('TrainingPlatform')">
                    <div class="case-icon">
                      <img src="./img/Insight@2x.png" alt="" srcset="">
                    </div>
                    <div class="case-content">
                      <h4>AI实训平台</h4>
                      <p>人工智能赋能竞赛实训</p>
                    </div>
                  </div>
                  <div class="case-item case-item-cursor" @click="handleCaseClick('StandardTraining')">
                    <div class="case-icon">
                      <img src="./img/Interactive@2x.png" alt="" srcset="">
                    </div>
                    <div class="case-content">
                      <h4>标训推一体化平台</h4>
                      <p>训推一体，智赋未来</p>
                    </div>
                  </div>
                  <div class="case-item case-item-cursor" @click="handleCaseClick('LargemodelService')">
                    <div class="case-icon">
                      <img src="./img/User-Community@2x.png" alt="" srcset="">
                    </div>
                    <div class="case-content">
                      <h4>大模型服务平台</h4>
                      <p>让每个企业拥有专属AI大脑</p>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </el-dropdown-menu>
  </div>
</template>
<script setup>
import { useRouter } from 'vue-router';
import { defineEmits } from 'vue';

const emit = defineEmits(['close-dropdown']);
const router = useRouter();

const handleCaseClick = (value) => {
  router.push(`/${value}/index`);
  emit('close-dropdown');
};
</script>

<style scoped>
/* 客户案例下拉菜单样式 */
.case-dropdown .el-dropdown-menu {
  padding: 20px 0;
  min-width: 800px;
  border-radius: 0;
  margin-top: 0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

/* 响应式调整 */
@media screen and (max-width: 1200px) {
  .case-container .el-row {
    flex-wrap: wrap;
  }

  .case-container .el-col-6 {
    width: 50%;
    margin-bottom: 20px;
  }
}

.case-container {
  padding: 20px;
}

.case-section {
  padding: 0 15px;
  text-align: left;
  border-right: 1px solid #eee;
  height: 100%;
  margin-top: 15px;
}

.case-section:last-child {
  border-right: none;
}

/* 左侧图片区域样式 */
.case-image {
  width: 220px;
  position: relative;
  height: 100%;
  /* border-right: 1px solid #eee; */
  padding-right: 15px;
  margin-left: 120px;  /* 向右移动120px */
}

.case-image img {
  width: 100%;
  height: 143.67px;
  object-fit: cover;
  border-radius: 4px;
  margin-top: 14px;
}

.image-desc {
  margin-top: 15px;
}


.image-desc p {
  color: #677489;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
}

.case-section .section-top {
  color: #677489;
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.section-desc {
  color: #97a3b7;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.section-desc span {
  color: #3448FF;
}

.case-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  cursor: default;
}
.case-item-cursor {
  cursor: pointer;
}

.case-icon {
  margin-right: 10px;
  flex-shrink: 0;
  width: 25px;
  height: 25px;
}

.case-icon img {
  width: 100%;
}

.case-content h4 {
  color: #333;
  font-size: 16px;
  margin: 0 0 5px 0;
}

.case-content p {
  color: #666;
  font-size: 14px;
  margin: 0;
}

/* 移动端样式 */
@media (max-width: 768px) {
  /* 只隐藏左侧图片区域 */
  .case-container > .el-row > .el-col:first-child {
    display: none !important;
  }

  /* 右侧内容区域占满宽度 */
  .case-container > .el-row > .el-col:nth-child(2) {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }


  /* 放大文字大小 */
  .case-content h4 {
    font-size: 9px !important;
  }
  
  .case-content p {
    font-size: 8px !important;
    line-height: 15px;
  }
  .section-top	{
    font-size: 10px !important;
    margin-top:10px  !important;
  }
  .section-desc	{
    font-size: 8px !important;
    margin-top:10px  !important;
    margin-bottom:20px  !important;
    line-height: 10px;
  }
   /* 放大图片大小 */
  .case-icon {
    margin-right:5px;
  img {
  width: 45px;
  height: 45px;
    }
  }
}

/* 增加右侧宽度的简单方法 */
.case-container {
  max-width: 1500px !important;  /* 增加整个容器的最大宽度 */
  margin: 0 auto;
}
</style>